import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a65e6c6c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=a65e6c6c&prod&lang=stylus&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=a65e6c6c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e6c6c",
  null
  
)

export default component.exports